import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=2dcf63fc&scoped=true"
import script from "./Loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loading.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Loading.vue?vue&type=style&index=0&id=2dcf63fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcf63fc",
  null
  
)

export default component.exports